<template>
  <div>
  <div id="prop-about" class="prop-about">
    <h2 :title="property.original_name">
      About this property
      <button class="show-more" @click="toggle" v-if="showMore" :class="{more: showMore}" aria-label="Show more">
        <b>Show less</b>
        <svg class="icon" :class="{down: !showMore}">
          <use xlink:href="#ico-arr"></use>
        </svg>
      </button>
    </h2>
    <div class="prop-about prop-fees prop-pets" v-if="property.pets && !loading && propertyAvailable">
      <h3>Pets information</h3>
      <div v-if="price.unit_pet_fee" class="pet-fee">
        <p>Pet fees apply. From {{ price.unit_pet_fee | money }} per pet.</p>
        <p>This is not included in the displayed price but will amend when you select your number of pets during the
          booking process.</p>
      </div>
      <div v-else>
        <p>
          <span v-if="property.source !== 'Sykes Cottages' && property.source !== 'Booking Com Payment' && property.source !== 'Independent Cottages'">
            Pets can stay at this property for free & can be added during the checkout process.
          </span>
          <span v-else>Pets can be added during the checkout process.</span>
        </p>
      </div>
    </div>
    <div class="cont" :class="{more: showMore}" id="about-content">
      <div v-if="renderedText" v-html="renderedText"></div>
      <div v-if="property.infants_allowed || property.children_allowed">
        <h3>Important - please note</h3>
        <p v-if="!property.infants_allowed && !property.children_allowed">
          Sorry, neither infants (aged under 2) or children (aged between 2 and 17) are not allowed at this property.
        </p>
        <p v-if="!property.infants_allowed">
          Sorry, infants (aged under 2) are not allowed at this property.
        </p>
        <p v-if="!property.children_allowed">
          Sorry, children (aged between 2 and 17) are not allowed at this property.
        </p>
      </div>
      <div v-if="property.source === 'Expedia' && bookingNotes">
        <h3>Room details</h3>
        <div class="prop-info" v-if="bookingNotes.bed_groups">
          <div class="inline" v-for="(room, index) in Object.values(bookingNotes.bed_groups)[0].configuration">
            <b>Bedroom {{ index+1 }}:</b>
            <span>{{ room.quantity }} {{ room.type }}</span>
          </div>
        </div>
        <h3>About this stay</h3>
        <div class="prop-info">
          <div class="inline" v-if="bookingNotes.check_in">
            <b>Check-in:</b>
            <span v-if="bookingNotes.check_in.begin_time">
              {{ bookingNotes.check_in.begin_time }}
            </span>
            &nbsp;-&nbsp;
            <span v-if="bookingNotes.check_in.end_time">
              {{ bookingNotes.check_in.end_time }}
            </span>
          </div>
          <div class="inline" v-if="bookingNotes.check_out">
            <b>Check-out:</b>
            <span>{{ bookingNotes.check_out.time }}</span>
          </div>
          <div class="block" v-if="bookingNotes">
            <b>Instructions:</b>
            <div v-html="bookingNotes.check_in.instructions"/>
          </div>
          <div class="block" v-if="bookingNotes.check_in.special_instructions">
            <b>Special instructions:</b>
            <div v-html="bookingNotes.check_in.special_instructions"></div>
          </div>
          <div class="inline" v-if="bookingNotes.check_in.min_age">
            <b>Minimum age:</b>
            <span>{{ bookingNotes.check_in.min_age }}</span>
          </div>
          <div class="block" v-if="bookingNotes.fees">
            <b>Fees:</b>
            <div v-html="bookingNotes.fees.mandatory"/>
          </div>
          <div class="block" v-if="bookingNotes.policies">
            <b>Policies:</b>
            <div v-html="bookingNotes.policies.know_before_you_go"/>
          </div>
        </div>
      </div>
      <div v-if="secondBitOfBody !== '<p></p>' || features !== '<p></p>'">
        <h3>Accommodation</h3>
        <div v-if="features !== '<p></p>'" v-html="renderedFeatures" class="features"></div>
        <div v-if="secondBitOfBody !== '<p></p>'" v-html="renderedTextSecond" class="secondBitOfBody"></div>
      </div>
    </div>
    <button class="show-more" @click="toggle" :class="{more: showMore}" aria-label="Show more">
      <b v-if="!showMore">Show more</b>
      <b v-else>Show less</b>
      <svg class="icon" :class="{down: !showMore}">
        <use xlink:href="#ico-arr"></use>
      </svg>
    </button>
  </div>
    <div class="prop-about prop-fees" v-if="property.source === 'Original Cottages'">
      <h3>Fees</h3>
      <p>A fully refundable security deposit may apply to this property to cover potential damages.</p>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      bookingNotes: "",
    }
  },
  props: {
    property: Object,
    propertyAvailable: Boolean,
    price: Object,
    firstBitOfBody: String,
    headingCaption: String,
    secondBitOfBody: String,
    features: String,
    showMore: Boolean,
    renderedText: String,
    renderedTextSecond: String,
    renderedFeatures: String,
    loading: Boolean
  },
  filters: {
    money: function(val) {
      return st.money(val)
    }
  },
  methods: {
    toggle() {
      this.$emit('toggleCopy');
    }
  },
  created() {
    if (this.property.booking_notes){
      this.bookingNotes = JSON.parse(this.property.booking_notes);
    }
  }
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.prop-about {
  padding-bottom: 1.25rem;
  margin: 0 1.25rem 1.25rem;
  border-bottom: 1px solid #D9D9D9;

  h2 {
    display: flex;
    margin: 1.25rem 0;
    font-size: 1.25rem;
    flex-direction: row;
    line-height: 1.25rem;
    justify-content: space-between;
  }

  &.prop-pets {
    margin: 0 0 1.25rem;
  }

  .pet-fee {
    p:first-of-type {
      margin-bottom: 1.25rem;
    }
  }

  &.prop-fees {
    p,span {
      font-size: .875rem;
    }
  
    h3 {
      margin-bottom: .625rem;
    }
  }

  .cont {
    overflow: hidden;
    animation: slideIn 1s ease-in forwards;
    height: 12.5rem;

    &.more {
      height: 100%;
    }

    h3 {
      margin-bottom: .625rem;
      font-size: 1rem;
      line-height:  1.125rem;;
    }

    p {
      font-size: 0.875rem;
      line-height: 1.125rem;
      margin-bottom: 1.25rem;
    }

    .highlighted {
      color: $col_white;
      background-color: var(--primary-color);
    }
  }

  .show-more {
    display: flex;
    cursor: pointer;
    margin-top: 1.25rem;
    align-items: center;
    flex-direction: row;
    background: transparent;

    &.more {
      margin-top: 0;
    }

    b {
      font-size: .875rem;
      line-height: 1.188rem;
      margin-right: .425rem;
      letter-spacing: -0.38px;
      color: var(--primary-color);
    }

    svg {
      width: 0.938rem;
      height: 0.8rem;
      fill: var(--primary-color);
      transform: rotate(-90deg);

      &.down {
        transform: rotate(90deg);
        margin-bottom: -.15rem;
      }
    }

    &:hover {
      b {
        text-decoration: underline;
      }
    }
  }

  .prop-info {
    margin-bottom: 1.25rem;

    b {
      display: block;
      margin-right: .625rem;
      margin-bottom: 0.625rem;
    }

    ul {
      padding: 0 0 0 1.25rem;
      list-style: disc;

      li {
        margin-bottom: 0.625rem;
      }
    }

    .block {
      margin-bottom: 1.25rem;

      p {
        margin-bottom: .625rem;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    .inline {
      display: flex;
      flex-direction: row;
    }
  }

  @media #{$desktop} {
    margin: 0 0 1.25rem;

    h2 {
      font-size: 1.5rem;
      line-height: 1.813rem;
    }

    &.prop-fees {
      p,span {
        font-size: 1rem;
      }
    
      h3 {
        margin-bottom: .625rem;
      }
    }

    .cont {
      h3 {
        font-size: 1.25rem;
        line-height: 1.25rem;
      }

      p {
        font-size: 1rem;
        line-height: 1.25rem;
      }
    }

    .show-more {
      b {
        font-size: 1rem;
        line-height: 1.188rem;
      }
    }
  }
}
</style>
